export default function OurInsurers() {

    return (
        <span className="sidebar-component">
            <p className="sidebar-header">Our Insurers</p>
            <table>
            <tbody>
                    <tr>
                        <td><img className="our-insurers-logo" src={require('../../../assets/ourInsurers/aviva_logo.png')} alt="aviva-logo" /></td>
                        <td><img className="our-insurers-logo" src={require('../../../assets/ourInsurers/axa_logo.png')} alt="axa-logo" /></td>
                        <td><img className="our-insurers-logo" src={require('../../../assets/ourInsurers/covea_logo.png')} alt="covea-logo" /></td>
                    </tr>
                    <tr>
                        <td><img className="our-insurers-logo" src={require('../../../assets/ourInsurers/hsb_logo.png')} alt="hsb-logo" /></td>
                        <td><img className="our-insurers-logo" src={require('../../../assets/ourInsurers/markel_logo.png')} alt="markel-logo" /></td>
                        <td><img className="our-insurers-logo" src={require('../../../assets/ourInsurers/sagic_logo.png')} alt="sagic_logo" /></td>
                    </tr>
                    <tr>
                        <td><img className="our-insurers-logo" src={require('../../../assets/ourInsurers/tm_hcc_logo.png')} alt="tm-hcc-logo" /></td>
                        <td><img className="our-insurers-logo" src={require('../../../assets/ourInsurers/toledo_logo.png')} alt="toledo-logo" /></td>
                        <td><img className="our-insurers-logo" src={require('../../../assets/ourInsurers/zurich_logo.png')} alt="zurich-logo" /></td>
                    </tr>
                </tbody>
            </table>

            <p className="our-insurers-paragraph">And more</p>
        </span>
    )

}